/* src/app/modules/members/member-admincontrol/member-control-overview/member-control-overview.component.scss */
.tableoverflow {
  width: 100%;
  overflow: auto;
  margin-bottom: 70px;
}
table {
  min-width: 100%;
}
table .mat-mdc-row:hover {
  background-color: rgb(247, 247, 250);
}
table .selected-row {
  background-color: rgb(214, 214, 214);
}
button.mat-mdc-fab {
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 1000;
}
.filterrow .mat-mdc-form-field {
  padding: 5px;
}
.hidden {
  display: none;
}
/*# sourceMappingURL=member-control-overview.component.css.map */
